export default {
  name: 'cultivationitem',
  props: ['index', 'source', 'onClick', 'onClickDelete', 'onClickProducts', 'onClickContinuedCrops'],
  data () {
    return {
    }
  },
  computed: {
    numActions () {
      return (this.source.productIDs.length > 0 ? 1 : 0) + (this.source.video ? 1 : 0) + 4
    }
  }
}
